import { render, staticRenderFns } from "./MusicPanel.vue?vue&type=template&id=05d56f3f&scoped=true&"
import script from "./MusicPanel.vue?vue&type=script&lang=js&"
export * from "./MusicPanel.vue?vue&type=script&lang=js&"
import style0 from "./MusicPanel.vue?vue&type=style&index=0&id=05d56f3f&lang=scss&scoped=true&"
import style1 from "./MusicPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d56f3f",
  null
  
)

export default component.exports